(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('AnomalyExceptionsV2Controller', ["$scope", "$q", "widgetSettings", "tablePaginationHelper", "defaultListConverter", "modulesManager", "modals", "columnsHelper", "avananUserDao", "anomalyExceptionsDao", function ($scope, $q, widgetSettings, tablePaginationHelper, defaultListConverter, modulesManager, modals, columnsHelper, avananUserDao, anomalyExceptionsDao) {
        $scope.initializing = true;
        $q.all([avananUserDao.users()]).then(function (responses) {
            $scope.options = {
                columns: [
                    {
                        id: 'id',
                        hidden: true,
                        primary: true
                    },
                    {
                        id: 'added_by',
                        text: 'Created by'
                    },
                    {
                        id: 'anomaly_type',
                        text: 'Anomaly Type'
                    },
                    {
                        id: 'exception_rule',
                        text: 'Details',
                        converter: 'keyValueConverter',
                        hidden: false
                    },
                    {
                        id: 'insert_time',
                        converter: 'localTimeConverter',
                        text: 'Created at',
                        sortable: true
                    },
                    {
                        id: 'enabled',
                        hidden: true
                    },
                    {
                        id: 'event_id',
                        hidden: true
                    },
                    {
                        id: 'customer_domain',
                        hidden: true
                    },
                    {
                        id: 'expiration_date',
                        hidden: true
                    },
                    {
                        id: 'comments',
                        hidden: true
                    },
                    {
                        id: 'update_time',
                        hidden: true
                    }
                ],
                options: {
                    checkboxes: true,
                    defaultOrdering: {
                        columnName: 'insert_time',
                        order: 'desc'
                    }
                }
            };
            $scope.tableOptions = {
                disableTop: true,
                orderDisplayMode: 'highlight-column',
                asDivs: true,
                infinite: true,
                showWorkingIndicator: true,
                workingIndicatorDisableGui: false,
                saveState: true,
                headerOptions: { enum: { multiple: true } },
                pagination: {
                    pageSize: 10,
                    ordering: {}
                },
                dropdownHeader: true,
                actions: [{
                        label: 'Delete...',
                        display: 'button',
                        active: function () {
                            return $scope.tableHelper.getSelectedIds().length > 0;
                        },
                        execute: function () {
                            var message, title = 'Delete Exception', selectedIds = $scope.tableHelper.getSelectedIds();
                            if (!selectedIds.length) {
                                return;
                            }
                            if (selectedIds.length === 1) {
                                message = 'Are you sure you want to delete selected exception?';
                            } else {
                                message = 'Are you sure you want to delete ' + selectedIds.length + ' selected exceptions?';
                                title += 's';
                            }
                            modals.confirm({
                                message: message,
                                title: title,
                                okText: 'Delete'
                            }).then(function () {
                                var removeData = {};
                                removeData.rule_id = [];
                                _(selectedIds).each(function (id) {
                                    removeData.rule_id.push(id);
                                });
                                return anomalyExceptionsDao.remove(removeData);
                            }).then(function () {
                                $scope.tableHelper.clearSelection();
                                $scope.tableHelper.reload();
                            });
                        }
                    }]
            };
            $scope.userMap = _(responses[0].data.rows).chain().map(function (row) {
                return [
                    row.email,
                    {
                        email: row.email,
                        name: _([
                            row.first_name,
                            row.last_name
                        ]).compact().join(' ')
                    }
                ];
            }).object().value();
            if ($scope.options.options.noFilter) {
                delete $scope.tableOptions.pagination.filter;
            }
            $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                var q = anomalyExceptionsDao.list();
                var params;
                if (args.columnsFilters) {
                    params = columnsHelper.filtersToParams(args.columnsFilters);
                    params.resolve = true;
                    q.params(params);
                }
                return q.pagination(args.offset, args.limit).filter(args.filter).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, function (preFetches) {
                    return {
                        columns: $scope.options.columns,
                        converters: {
                            avananUserInfoConverter: function (text, columnId, columnsMap, args, allConverters) {
                                var userInfo = $scope.userMap[text] || {};
                                return allConverters.userWithEmail(userInfo.name, columnId, userInfo, {
                                    emailColumn: 'email',
                                    userIdColumn: 'noIdNeeded'
                                });
                            },
                            localTimeConverter: function (text) {
                                if (text) {
                                    var convertedTime = moment.utc(text.trim()).local();
                                    return '#' + JSON.stringify({
                                        display: 'text',
                                        text: convertedTime.format('YYYY-MM-DD HH:mm:ss')
                                    });
                                }
                            },
                            keyValueConverter: function (text, columnId, columnsMap, args) {
                                var values = '';
                                if (text && _(text).isObject()) {
                                    _(text).each(function (val, key) {
                                        values += '#' + JSON.stringify({
                                            display: 'text',
                                            text: key + ': '
                                        }) + '#' + JSON.stringify({
                                            display: 'text',
                                            text: val
                                        }) + '#' + JSON.stringify({
                                            display: 'html',
                                            text: '<br>'
                                        });
                                    });
                                }
                                return values;
                            }
                        }
                    };
                });
            }, function (tableModel) {
                $scope.initializing = false;
                $scope.tableModel = tableModel;
                $scope.tableOptions.infoText = 'Total exceptions found: ' + $scope.tableHelper.getTotal();
            });
        });
    }]);
}());